export default "__VITE_ASSET__BdtS2H1U__"